<script>
import {
  paymentMethodProduitsIncompatiblesProps,
  usePaymentMethodProduitsIncompatibles
} from "./mixin";
import GridCol from "@/components/molecules/grid/grid-col";
import GridRow from "@/components/molecules/grid/grid-row";
import Divider from "@/components/atoms/divider/index";
import LazyImage from "@/components/atoms/lazy-image";
import Button from "@/components/atoms/button";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import StickyFooter from "@/components/molecules/sticky-footer";
import Container from "@/components/atoms/container";

export default {
  name: "PaymentMethodProduitsIncompatibles",
  components: {
    Button,
    List,
    ListItem,
    Divider,
    GridCol,
    GridRow,
    LazyImage,
    Container,
    StickyFooter
  },
  props: {
    ...paymentMethodProduitsIncompatiblesProps()
  },
  emits: ["cancel"],
  setup(props) {
    const { produitsIncompatiblesUniques } =
      usePaymentMethodProduitsIncompatibles(props);
    return { produitsIncompatiblesUniques };
  }
};
</script>

<template>
  <div
    v-if="modePaiement"
    class="u-full-height u-bgcolor-white u-flex u-flex-column u-flex-align-center"
  >
    <div class="u-mx-sm u-p-sm u-mb-md u-font-secondary u-font-700 u-font-20 u-color-primary u-text-center">
      Le mode de paiement {{ modePaiement }} n'est pas disponible pour les produits suivants :
    </div>
    <Container class="u-flex-grow">
      <List>
        <ListItem
          v-for="produit in produitsIncompatiblesUniques"
          :key="produit.id"
        >
          <Divider dotted />
          <GridRow class="u-flex-align-center u-pt-sm u-pb-sm">
            <GridCol class="o-col--3">
              <LazyImage
                :dimension="190"
                width="150"
                height="150"
                :src="produit.attributes.produit.data.attributes.visuel"
                class="u-height-auto"
              />
            </GridCol>
            <GridCol class="o-col--9 o-col--no-gutter ">
              <p class="u-font-16 u-font-500 u-mb-xs">
                {{ produit.attributes.designation }}
              </p>
            </GridCol>
          </GridRow>
          <GridRow class="u-flex-align-center u-pb-sm ">
            <GridCol class="o-col--8 u-flex u-flex-row u-flex-justify-start">
            </GridCol>
            <GridCol class="o-col--4 u-text-right">
              <div>
                <p class="u-font-20 u-font-700 u-color-secondary">
                  {{ formatPrix(produit.attributes.prix) }} €
                </p>
              </div>
            </GridCol>
          </GridRow>
        </ListItem>
      </List>
      <Divider dotted />
    </Container>
    <StickyFooter
      class="u-flex u-flex-column"
      :in-dom="false"
    >
      <p class="u-text-center">
        <Button
          variant="primary"
          radius="full"
          size="md"
          @click="$emit('cancel')"
        >
          Choisir un autre mode de paiement
        </Button>
      </p>
    </StickyFooter>
  </div>
</template>
